module.exports = __webpack_public_path__ + "media/images/new-ui-images/cross-icon-6d34872caba004e93d1de9d9b16c7d0c.svg";